import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/task-groups'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'task_groups_index',
          component: Index,
          meta: {
            permissions: [...ROLES],
          },
        },
      ],
    },
  ],
};
